import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import { useNavigate } from "react-router-dom";
// import DeleteIcon from "@mui/icons-material/Delete";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { TrackMenuProps } from "../types";
import { TrackMenuContainer } from "../styles";
import { Collaborator, TrackState } from "../../../proto/api_pb";
import { useContext, useEffect } from "react";
import {
  TalkJsContext,
  TalkJsContextInterface,
  UserDetailsContext,
} from "../../../contexts";
import { UserDetailsContextInterface } from "../../../contexts";
import { TrackPrivacySwitch } from "../TrackPrivacySwitch/TrackPrivacySwitch";
import { TEXT_COLOR, THEME, isEnterprise } from "../../../theme";
import { useTheme } from "@mui/material/styles";
import { styles } from "./styles";
import { handleCreateGroupChat } from "../TrackHandler/trackHandlers";
import { useAuth0 } from "@auth0/auth0-react";

export const TrackMenu: React.FC<TrackMenuProps> = ({
  handleOpenVersionModal,
  id,
  downloadSong,
  handleOpen,
  setIsMasterModalOpen,
  isMasterModalOpen,
  userVerified,
  track,
  trackUrl,
  openDeleteConfirmModal,
  expand,
  handleOpenTrackFileModal,
  isTrackPublished,
  setIsTrackPublished,
  hasPaymentMethod,
  handleMasterModalOpen,
  isTrackConnectedToTutorial,
  allowDownload,
  setSelectedTrackForShare,
  setIsShareDetailsModalOpen,
  handleOpenPublishModal,
  upsertTrackInState,
  session,
  setInbox,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { connectedWallet } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const isSharedContentPage = window.location.pathname.includes("/share/");
  const { isAuthenticated } = useAuth0();
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);

  const handleMinting = (e: any) => {
    e.stopPropagation();
    if (!hasPaymentMethod) {
      navigate("/settings", {
        state: { panel: "hasPaymentMethod" },
      });
    } else if (connectedWallet === "") {
      navigate("/settings", {
        state: { panel: "connectedWallet" },
      });
    } else {
      navigate(`/mint`, {
        state: {
          trackArtist: track?.getArtist(),
          trackUrl: trackUrl,
          trackTitle: track?.getTitle(),
          trackBpm: track?.getBpm(),
          trackKeyNote: track?.getKey()?.getNote(),
          trackKey: track?.getKey()?.getKey(),
          trackKeyScale: track?.getKey()?.getScale(),
          trackGenre: track?.getSongMetadata()?.getGenre(),
          trackDescription: track?.getDescription(),
          trackImageUrl: track?.getImageUrl(),
          trackContributors: track
            ?.getCollaboratorsList()
            .map((collaborators: any) => collaborators.getUsername()),
          trackId: track?.getId(),
        },
      });
    }
  };

  const createGroupChat = (
    id: string | undefined,
    title: string | undefined,
    contributors: Collaborator[] | undefined
  ) => {
    handleCreateGroupChat(
      talkJsContext,
      contributors,
      navigate,
      undefined,
      id,
      title
    );
  };

  useEffect(() => {
    if (track?.getState() === TrackState.TRACK_STATE_PUBLISHED) {
      setIsTrackPublished(true);
    } else {
      setIsTrackPublished(false);
    }
  }, [setIsTrackPublished, track]);

  return (
    <TrackMenuContainer>
      <span id="track-privacy-switch">
        {!isSharedContentPage && (
          <TrackPrivacySwitch
            isTrackPublished={isTrackPublished}
            isTrackConnectedToTutorial={isTrackConnectedToTutorial}
            track={track}
            setIsTrackPublished={setIsTrackPublished}
            handleOpenPublishModal={handleOpenPublishModal}
            upsertTrackInState={upsertTrackInState}
          />
        )}
      </span>
      {!isSharedContentPage && (
        <Tooltip title="Add Version">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-13" : ""}
              sx={{ color: TEXT_COLOR, zIndex: 1000 }}
              aria-label="add-version"
              onClickCapture={(e) => {
                if (handleOpenVersionModal) {
                  e.stopPropagation();
                  handleOpenVersionModal(id!);
                }
              }}
            >
              <AddIcon sx={{ fontSize: 30 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {!isSharedContentPage && (
        <Tooltip title="Add File">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-14" : ""}
              sx={{ color: TEXT_COLOR, zIndex: 1000 }}
              aria-label="add-file"
              onClickCapture={(e) => {
                if (handleOpenTrackFileModal) {
                  e.stopPropagation();
                  handleOpenTrackFileModal(id!);
                }
              }}
            >
              <NoteAddIcon sx={{ fontSize: 25 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {isSharedContentPage && isAuthenticated && (
        <Tooltip title="Message">
          <IconButton
            sx={{ marginTop: -2 }}
            onClick={(e) => {
              e.stopPropagation();
              if (session && setInbox) {
                const talkInbox = session.createInbox();
                setInbox(talkInbox);
                talkJsContext.setIsChatOpen(true);
                const trackId = track?.getId();
                const trackTitle = track?.getTitle();
                const contributors = track?.getCollaboratorsList();
                if (trackId && trackTitle) {
                  createGroupChat(trackId, trackTitle, contributors);
                }
              }
            }}
          >
            <Tooltip placement="top" title="Chat with the artists">
              <img
                style={{
                  filter:
                    THEME === "light" ? "invert(100%)" : "contrast(1000%)",
                }}
                src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
                alt="icon"
              />
            </Tooltip>
          </IconButton>
        </Tooltip>
      )}
      {(!isSharedContentPage || (isSharedContentPage && allowDownload)) && (
        <Tooltip title="Download Current Version">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-15" : ""}
              sx={{ color: TEXT_COLOR, zIndex: 1000 }}
              aria-label="download"
              onClickCapture={(e) => {
                e.stopPropagation();
                downloadSong();
              }}
            >
              <DownloadIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {!isSharedContentPage && (
        <Tooltip title="Edit">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-16" : ""}
              sx={{ color: TEXT_COLOR, zIndex: 1000 }}
              aria-label="edit"
              onClickCapture={(e) => {
                e.stopPropagation();
                handleOpen(id!);
              }}
            >
              <EditIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {!isSharedContentPage && (
        <Tooltip title="Master">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-17" : ""}
              sx={{ color: "white", zIndex: 1000, marginRight: 1 }}
              aria-label="master"
              onClickCapture={(e) => {
                e.stopPropagation();
                handleMasterModalOpen();
              }}
            >
              <img
                style={
                  theme.palette.mode === "light"
                    ? { backgroundColor: "black" }
                    : {}
                }
                height="24px"
                width="24px"
                src={`/assets/svg/dolby.svg`}
                alt=""
              />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {userVerified && !isSharedContentPage && !isEnterprise && (
        <Tooltip title="Mint">
          <span>
            <IconButton
              id={isTrackConnectedToTutorial ? "step-18" : ""}
              sx={{ zIndex: 1000, marginLeft: -1 }}
              aria-label="master"
              onClickCapture={(e) => handleMinting(e)}
            >
              <img
                style={
                  theme.palette.mode === "light"
                    ? { backgroundColor: "black" }
                    : {}
                }
                height="24px"
                width="24px"
                src={`/assets/images/ethereum.svg`}
                alt=""
              />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {/* <Tooltip title="Delete">
        <IconButton
          sx={{ color: "white", zIndex: 1000 }}
          aria-label="delete"
          onClickCapture={(e) => {
            e.stopPropagation();
            openDeleteConfirmModal!(id!);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip> */}
      {!isSharedContentPage && (
        <Tooltip title="Share">
          <span>
            <IconButton
              sx={{ color: TEXT_COLOR, zIndex: 1000 }}
              aria-label="share"
              onClickCapture={async (e) => {
                e.stopPropagation();
                if (track?.getId()) {
                  setSelectedTrackForShare(track);
                  setIsShareDetailsModalOpen(true);
                }
              }}
            >
              <ShareIcon sx={{ fontSize: 23 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {expand && !isSharedContentPage ? (
        <Tooltip title="Minimize">
          <IconButton
            onClickCapture={() => navigate(-1)}
            sx={styles.minimizeMaximizeButton}
          >
            <FullscreenExitIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Open Track Page">
          {!isSharedContentPage ? (
            <IconButton
              onClickCapture={(e) => {
                e.stopPropagation();
                navigate(`/track/${id}`, { state: { id: id } });
              }}
              sx={styles.minimizeMaximizeButton}
            >
              <FullscreenIcon />
            </IconButton>
          ) : (
            <></>
          )}
        </Tooltip>
      )}
    </TrackMenuContainer>
  );
};
